import { downloadCSV } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

const exporter = subCategoriesTerroirs => {
    const data = subCategoriesTerroirs.map(subCategoryTerroirs => ({
        id: subCategoryTerroirs.id,
        categoria_terroirs: subCategoryTerroirs.category_terroirs_name,
        nome_pt_br: subCategoryTerroirs.name.pt_br,
        nome_en_us: subCategoryTerroirs.name.en_us,
        criado_em: subCategoryTerroirs.created_at_format
    }));
    const csv = convertToCSV({
        data,
        fields: ['id', 'categoria_terroirs', 'nome_pt_br', 'nome_en_us', 'criado_em']
    });
    downloadCSV(csv, 'subCategoriesTerroirs');
}

export default exporter;
